import type { AppNotification, NotificationsSummary } from "../domain";
import type {
  NotificationDto,
  NotificationsSummaryDto,
} from "./notificationDtos";

export function notificationFromDto(dto: NotificationDto): AppNotification {
  return { ...dto };
}

export function notificationsSummaryFromDto(
  dto: NotificationsSummaryDto,
): NotificationsSummary {
  return { ...dto };
}
